module.exports = __webpack_public_path__ + "img/page_bg_videoTracing.be0db524.png";